import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';

export default mutatorAction('removeServiceCallMutator', function removeServiceCallMutator() {
    getStore().serviceCalls.shift();
});
